<template>
  <div class="flex items-center gap-1">
    <el-tooltip placement="top" content="View Comments">
      <button
        type="button"
        @click="$emit('view')"
        class="p-1.5 rounded-full text-untitled-gray-400 hover:text-untitled-gray-600 hover:bg-untitled-gray-100 transition-colors"
      >
        <AnnotationIcon class="w-[18px] h-[18px]" />
      </button>
    </el-tooltip>
    <el-tooltip
      v-if="repliesCount > 0"
      placement="top"
      :content="`${isOpen ? 'Hide' : 'Open'} ${repliesCount} ${
        repliesCount === 1 ? 'Reply' : 'Replies'
      }`"
    >
      <button
        type="button"
        @click="$emit('toggle')"
        class="p-1.5 rounded-full text-untitled-gray-400 hover:text-untitled-gray-600 hover:bg-untitled-gray-100 transition-colors"
      >
        <ChatAlt2Icon class="w-[18px] h-[18px]" />
      </button>
    </el-tooltip>
    <template v-if="isOwner">
      <el-tooltip placement="top" content="Edit Comment">
        <button
          type="button"
          @click="$emit('edit')"
          class="p-1.5 rounded-full text-untitled-gray-400 hover:text-untitled-gray-600 hover:bg-untitled-gray-100 transition-colors"
        >
          <PencilIcon class="w-[18px] h-[18px]" />
        </button>
      </el-tooltip>
      <el-tooltip placement="top" content="Delete Comment">
        <button
          type="button"
          @click="$emit('delete')"
          class="p-1.5 rounded-full text-untitled-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
        >
          <TrashIcon class="w-[18px] h-[18px]" />
        </button>
      </el-tooltip>
    </template>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { ElTooltip } from "element-plus";
import {
  AnnotationIcon,
  ChatAlt2Icon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/vue/solid";

defineProps({
  repliesCount: {
    type: Number,
    default: 0,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  isOwner: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["view", "toggle", "edit", "delete"]);
</script>
